import {
    axios,
    useImperativeHandle, forwardRef, useRef, useContext, useState, useEffect,
    useSelector, useDispatch,
    useSearchParams, useLocation, useNavigate, Link,
    AppTheme,
    mui, reducer, component, useShared,  
    replaceTabVerseListNewItem, setRead, getYearOfBirthList, localizedDateTime, verseRangeChineseName, sortResultList, canPushNewEntry, Highlight, resetSelectedAll, getBookChapterVerseChineseName, getChapterChineseName, getBookChapterChineseName, getTabLabel,
    VERSION, COUNTRY_LIST, MAX_LENGTH_SEARCH_STRING, MAX_LENGTH_NOTE_CONTENT, MAX_LENGTH_NOTE_TITLE, SPACE, API_BASE_URL, MAX_LENGTH_NON_SEARCH_STRING1, MAX_LENGTH_NON_SEARCH_STRING2,
    homeContext, searchContext, noteContext,
} from '../Utilities/sharedHeader';

export default function ConfirmEmail4SignUp() {  

  const { SignUpEmailSent, Profile4System, Profile4Personal, History, AddChangeNote, FullFormatVerse, Book, Stack1, NoteVerseList, Chapter, Dialog1, Dialog2, Dialog3, Dialog4, Tab1, Navbar, VerseSearch, Verse, NoteBookmarkList, NoteBookmarkListItem, VerseLabelArrows4Result, ConfirmationDialog, Accordion1, ChipArray, SearchResult, ForgotPassword, ClipLoader1, VerseLabelArrows, Switch1, Selection, Profile, UserListItem } = component;  
  const { verifyEmail4SignUp, postUserListItem, bookRead, deleteVerseReadLogList, getNoteBookmarkList3, deleteLogListItem, getToken, postLogListItem, postPutSearchCriteriaListItem, deleteVerseReadLogListItem, postPutVerseReadLogListItem, postHistoryListItem, getHasNoteVersesAll, getSearchResultVerseList, getSearchCriteriaListItem, postNoteBookmarkListItem, putNoteBookmarkListItem2, putNoteBookmarkListItem1, getNoteBookmarkList, getVerseReadLogList4Book, getSearchScopeList, getVerseList4Accordion1, getUserListItem, getVerseList, getBookList, getHistoryList, putUserListItem } = useShared();
    
  const [loading4Home, setLoading4Home] = useState(false);

  const [searchParams] = useSearchParams();

  const verificationToken = searchParams.get('token');
  const email = searchParams.get('email');

  const navigate = useNavigate();

  useEffect(() => {
    setLoading4Home(true);
    if (verificationToken && email) {
      verifyEmail4SignUp(email, verificationToken, 'ConfirmEmail4SignUp')
      .then((passed) => {
        switch(passed){
        case true:
          navigate('/confirm-email-sign-up-success');
          setLoading4Home(false);
          break;
        case false:
          navigate('/confirm-email-sign-up-failure');
          setLoading4Home(false);
          break;
        }
      });
    } else {
      navigate('/confirm-email-sign-up-failure');
      setLoading4Home(false);
    }
    //setLoading4Home(false);
  }, [verificationToken, email]);

  return (
    <div>
      {loading4Home && <ClipLoader1 />}
    </div>
  );
};